import { useState } from "react";
import { NavLink } from "react-router-dom";
import { ChevronDown } from "lucide-react";

/**
 * A collapsible second level in the sidebar. `defaultOpen` keeps the group holding the current
 * route expanded on load.
 */
export default function NavGroup({ icon: Icon, label, items, defaultOpen = false, emptyLabel }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`nav-group${open ? " open" : ""}`}>
      <button
        type="button"
        className="nav-item nav-group-toggle"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
      >
        <Icon className="nav-icon" size={19} strokeWidth={1.9} aria-hidden="true" />
        <span className="nav-label">{label}</span>
        <ChevronDown className="nav-chevron" size={16} strokeWidth={2.2} aria-hidden="true" />
      </button>

      {/* The 0fr→1fr row animation sizes a single track, so every item lives in one wrapper. */}
      <div className="nav-children" role="group">
        <div className="nav-children-inner">
          {items.length === 0 && emptyLabel && <span className="nav-empty">{emptyLabel}</span>}

          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `nav-item nav-child${isActive ? " active" : ""}`}
            >
              {item.icon ? (
                <item.icon className="nav-icon" size={17} strokeWidth={1.9} aria-hidden="true" />
              ) : (
                <span className="nav-dot" aria-hidden="true" />
              )}
              <span className="nav-label">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}
